// extracted by mini-css-extract-plugin
module.exports = {"back":"style_back__fOhMv","back-icon":"style_back-icon__OeAGl","back-text":"style_back-text__JRRBi"};